import { Box, Select } from 'vopay';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'UI';

export type TicketSearchParams = {
  user: string;
};

type SearchFormProps = {
  user: string;
  onSearch: (searchParams: TicketSearchParams) => void;
  users: string[];
};

export default function TicketListSearchForm({ user, onSearch, users }: SearchFormProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'TicketsList.SearchForm' });
  const [currentUser, setCurrentUser] = useState<string>(user);

  return (
    <Box jc="sb" flx="col" width="100%" gap="md">
      <Box gap="sm" wrap="wrap">
        <Box width="200px">
          <Select
            version="2"
            placeholder={t('user', { defaultValue: 'User' })}
            filterable
            options={[
              { value: '', label: t('all', { defaultValue: 'All' }) },
              ...users.map((user) => ({
                label: user,
                value: user,
              })),
            ]}
            name="type"
            value={currentUser}
            onBlur={() => {}}
            onChange={(e) => {
              setCurrentUser(e.target.value);
            }}
            sort={false}
          />
        </Box>

        <Button
          id="search-transaction-history"
          size="large"
          colorScheme="primary"
          onClick={() => {
            onSearch({
              user: currentUser,
            });
          }}
        >
          {t('search', { defaultValue: 'Search' })}
        </Button>
      </Box>
    </Box>
  );
}
